import styled from 'styled-components';
import CustomCircularProgress from 'src/common/components/CustomCircularProgress';
import MuiCircularProgress from '@mui/material/CircularProgress';
import { mobileBreakpoint } from '../mobileBreakpoint';

const CircularProgress = styled(MuiCircularProgress)`
  color: ${props => props.theme.green.regular};
`;

type WrapperProps = {
  progress: number;
};

const Wrapper = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  background-color: ${(props: WrapperProps) =>
    props.progress ? 'rgba(255, 255, 255, 0.5)' : 'transparent'};
  border-radius: 4px;
  border: ${(props: WrapperProps) =>
    props.progress ? '2px solid#457F8F' : '1px solid#515151'};
  margin: 4px 0;
  padding: 4px;
  color: ${(props: WrapperProps) => (props.progress ? '#101828;' : '#515151')};

  span {
    margin-left: 8px;
    font-size: 16px;
  }
  @media ${mobileBreakpoint.mobile} {
    padding: 12px;
    white-space: nowrap;
    margin: 0 20px;
    margin-left: 0;
    min-width: 80vw;
  }
`;

type Props = {
  item: { label: string; category: string };
  progress?: number;
};

function Item({ item, progress = 1 }: Props) {
  return (
    <Wrapper progress={progress}>
      <CustomCircularProgress
        variant="determinate"
        thickness={8}
        value={progress}
        size={25}
      />
      {/* <CircularProgress
        variant="determinate"
        thickness={8}
        value={progress}
        size={25}
      /> */}
      <span>{item.label}</span>
    </Wrapper>
  );
}

export default Item;
